import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../img/ic_close.svg'


const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 2,
  ref: "contentTagWrapper"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 6,
  ref: "contentTagWrapper"
}

export function render(_ctx, _cache) {
  const _component_LayoutCarousel = _resolveComponent("LayoutCarousel")
  const _component_ContainerTag = _resolveComponent("ContainerTag")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isBottomSheet)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.getClass('modal-overlay-bottom-sheet')),
          ref: "carouselModalOverlay"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.getClass('carousel_bottom_sheet')),
            ref: "carouselBottomSheet",
            onTouchstart: _cache[6] || (_cache[6] = (...args) => (_ctx.onDragStart && _ctx.onDragStart(...args))),
            onTouchmove: _cache[7] || (_cache[7] = (...args) => (_ctx.onDragMove && _ctx.onDragMove(...args))),
            onTouchend: _cache[8] || (_cache[8] = (...args) => (_ctx.onDragEnd && _ctx.onDragEnd(...args))),
            onMousedown: _cache[9] || (_cache[9] = (...args) => (_ctx.onDragStart && _ctx.onDragStart(...args))),
            onMousemove: _cache[10] || (_cache[10] = (...args) => (_ctx.onDragMove && _ctx.onDragMove(...args))),
            onMouseup: _cache[11] || (_cache[11] = (...args) => (_ctx.onDragEnd && _ctx.onDragEnd(...args))),
            style: _normalizeStyle({ transform: `translateY(${_ctx.translateY}px)` })
          }, [
            _createElementVNode("div", {
              onTouchstart: _cache[3] || (_cache[3] = (...args) => (_ctx.onDragStartHandle && _ctx.onDragStartHandle(...args))),
              onMousedown: _cache[4] || (_cache[4] = (...args) => (_ctx.onDragStartHandle && _ctx.onDragStartHandle(...args)))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClass('carousel_handle')),
                onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.closeModalList && _ctx.closeModalList(...args))),
                onTouchstart: _cache[1] || (_cache[1] = (...args) => (_ctx.onDragStartHandle && _ctx.onDragStartHandle(...args))),
                onMousedown: _cache[2] || (_cache[2] = (...args) => (_ctx.onDragStartHandle && _ctx.onDragStartHandle(...args)))
              }, null, 34 /* CLASS, NEED_HYDRATION */)
            ], 32 /* NEED_HYDRATION */),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.getClass('scroll_container')),
              onScroll: _cache[5] || (_cache[5] = (...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
            }, [
              _createVNode(_component_LayoutCarousel, {
                components: _ctx.carouselList.components,
                type: _ctx.carouselList.type,
                settings: Array.isArray(_ctx.carouselList.settings) ? {} : _ctx.carouselList.settings,
                layout: _ctx.carouselList.layout
              }, null, 8 /* PROPS */, ["components", "type", "settings", "layout"])
            ], 34 /* CLASS, NEED_HYDRATION */)
          ], 38 /* CLASS, STYLE, NEED_HYDRATION */)
        ], 2 /* CLASS */))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_ctx.getClass('modal-overlay-popup')),
          ref: "carouselModalOverlay"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.getClass('modal-popup')),
            style: _normalizeStyle(_ctx.styleContainer),
            ref: "carouselPopup"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.getClass('modal-wrapper-close')),
              ref: "modalCarouselClose"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClass('card-tag-wrapper'))
              }, [
                (_ctx.toggleTag.isCardTag && _ctx.tagPosition === 'top-right')
                  ? (_openBlock(), _createBlock(_component_ContainerTag, {
                      key: 0,
                      "tag-style": _ctx.styleTag,
                      text: _ctx.tagContent
                    }, null, 8 /* PROPS */, ["tag-style", "text"]))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */),
              _createElementVNode("div", {
                onClick: _cache[12] || (_cache[12] = (...args) => (_ctx.closeModalDetail && _ctx.closeModalDetail(...args)))
              }, [
                _createElementVNode("img", {
                  class: _normalizeClass(_ctx.getClass('modal-img-close')),
                  src: _imports_0,
                  alt: "close"
                }, null, 2 /* CLASS */)
              ])
            ], 2 /* CLASS */),
            (_ctx.isTopMiddle)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  ref: "modalComponentWrapper",
                  class: _normalizeClass(_ctx.getClass('modal-component-wrapper'))
                }, [
                  (!!_ctx.imageUrl)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        ref: "modalWrapperImage",
                        class: _normalizeClass(_ctx.getClass('modal-wrapper-image')),
                        style: {"width":"100%"}
                      }, [
                        _createElementVNode("img", {
                          ref: "modalImageEvent",
                          class: _normalizeClass(_ctx.getClass('modal-img-event')),
                          src: _ctx.imageUrl,
                          alt: _ctx.imageAlt,
                          width: "100%",
                          style: _normalizeStyle({ height: _ctx.imgHeight, aspectRatio: _ctx.imgAspectRatio, objectFit: _ctx.imgObjectFit, borderRadius: _ctx.imgBorderRadius })
                        }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_1),
                        (_ctx.toggleTag.isImageTag)
                          ? (_openBlock(), _createBlock(_component_ContainerTag, {
                              key: 0,
                              "tag-style": _ctx.styleTag,
                              text: _ctx.tagContent
                            }, null, 8 /* PROPS */, ["tag-style", "text"]))
                          : _createCommentVNode("v-if", true)
                      ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", {
                    ref: "modalContentWrapper",
                    class: _normalizeClass(_ctx.getClass('modal-content-wrapper'))
                  }, [
                    (_ctx.toggleTag.isCardTag && _ctx.tagPosition !== 'top-right')
                      ? (_openBlock(), _createBlock(_component_ContainerTag, {
                          key: 0,
                          "tag-style": _ctx.styleTag,
                          text: _ctx.tagContent
                        }, null, 8 /* PROPS */, ["tag-style", "text"]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.toggleTag.isTopContentTag)
                      ? (_openBlock(), _createBlock(_component_ContainerTag, {
                          key: 1,
                          "tag-style": _ctx.styleTag,
                          text: _ctx.tagContent
                        }, null, 8 /* PROPS */, ["tag-style", "text"]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.line1)
                      ? (_openBlock(), _createElementBlock("h4", {
                          key: 2,
                          class: _normalizeClass(_ctx.getClass('modal-title')),
                          style: _normalizeStyle({ ..._ctx.styleLine1 })
                        }, _toDisplayString(_ctx.line1.content), 7 /* TEXT, CLASS, STYLE */))
                      : _createCommentVNode("v-if", true),
                    (_ctx.line2)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 3,
                          class: _normalizeClass(_ctx.getClass('modal-description')),
                          style: _normalizeStyle({ ..._ctx.styleLine2 })
                        }, _toDisplayString(_ctx.line2.content), 7 /* TEXT, CLASS, STYLE */))
                      : _createCommentVNode("v-if", true),
                    (_ctx.html)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 4,
                          class: _normalizeClass(_ctx.getClass('modal-html-carousel')),
                          style: _normalizeStyle({ ..._ctx.styleHtml }),
                          innerHTML: _ctx.html && _ctx.html.content
                        }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_2))
                      : _createCommentVNode("v-if", true),
                    (_ctx.toggleTag.isBottomContentTag)
                      ? (_openBlock(), _createBlock(_component_ContainerTag, {
                          key: 5,
                          "tag-style": _ctx.styleTag,
                          text: _ctx.tagContent
                        }, null, 8 /* PROPS */, ["tag-style", "text"]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.showButton)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 6,
                          ref: "modalButtonWrapper",
                          class: _normalizeClass(_ctx.getClass('modal-button-wrapper'))
                        }, [
                          (_ctx.toggleTag.isTopButtonTag)
                            ? (_openBlock(), _createBlock(_component_ContainerTag, {
                                key: 0,
                                "tag-style": _ctx.styleTag,
                                text: _ctx.tagContent
                              }, null, 8 /* PROPS */, ["tag-style", "text"]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.button1 && _ctx.button1.label)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 1,
                                component: _ctx.button1Component,
                                messageContentsettings: _ctx.settings,
                                onClick: _ctx.onClickButton,
                                customStyle: _ctx.styleButton1
                              }, null, 8 /* PROPS */, ["component", "messageContentsettings", "onClick", "customStyle"]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.button2 && _ctx.button2.label)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 2,
                                component: _ctx.button2Component,
                                messageContentsettings: _ctx.settings,
                                onClick: _ctx.onClickButton,
                                customStyle: _ctx.styleButton2
                              }, null, 8 /* PROPS */, ["component", "messageContentsettings", "onClick", "customStyle"]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.button3 && _ctx.button3.label)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 3,
                                component: _ctx.button3Component,
                                messageContentsettings: _ctx.settings,
                                onClick: _ctx.onClickButton,
                                customStyle: _ctx.styleButton3
                              }, null, 8 /* PROPS */, ["component", "messageContentsettings", "onClick", "customStyle"]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" Render all dynamic buttons "),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allDynamicButtons, (buttonItem) => {
                            return (_openBlock(), _createBlock(_component_Button, {
                              key: buttonItem.key,
                              component: buttonItem.component,
                              messageContentsettings: _ctx.settings,
                              onClick: _ctx.onClickButton,
                              customStyle: buttonItem.style
                            }, null, 8 /* PROPS */, ["component", "messageContentsettings", "onClick", "customStyle"]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          (_ctx.toggleTag.isBottomButtonTag)
                            ? (_openBlock(), _createBlock(_component_ContainerTag, {
                                key: 4,
                                "tag-style": _ctx.styleTag,
                                text: _ctx.tagContent
                              }, null, 8 /* PROPS */, ["tag-style", "text"]))
                            : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */)
                ], 2 /* CLASS */))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  ref: "modalComponentWrapper",
                  class: _normalizeClass(_ctx.getClass('modal-component-wrapper'))
                }, [
                  (!!_ctx.imageUrl)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        ref: "modalWrapperImage",
                        class: _normalizeClass(_ctx.getClass('modal-wrapper-image'))
                      }, [
                        _createElementVNode("img", {
                          ref: "modalImageEvent",
                          class: _normalizeClass(_ctx.getClass('modal-img-event')),
                          src: _ctx.imageUrl,
                          alt: _ctx.imageAlt,
                          style: _normalizeStyle({ width: _ctx.imgWidth, height: _ctx.imgHeight, aspectRatio: _ctx.imgAspectRatio, objectFit: _ctx.imgObjectFit, borderRadius: _ctx.imgBorderRadius })
                        }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_3),
                        (_ctx.toggleTag.isImageTag)
                          ? (_openBlock(), _createBlock(_component_ContainerTag, {
                              key: 0,
                              "tag-style": _ctx.styleTag,
                              text: _ctx.tagContent
                            }, null, 8 /* PROPS */, ["tag-style", "text"]))
                          : _createCommentVNode("v-if", true)
                      ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true),
                  (_ctx.toggleTag.isCardTag && _ctx.tagPosition !== 'top-right')
                    ? (_openBlock(), _createBlock(_component_ContainerTag, {
                        key: 1,
                        "tag-style": _ctx.styleTag,
                        text: _ctx.tagContent
                      }, null, 8 /* PROPS */, ["tag-style", "text"]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.toggleTag.isTopContentTag)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_ContainerTag, {
                          "tag-style": _ctx.styleTag,
                          text: _ctx.tagContent
                        }, null, 8 /* PROPS */, ["tag-style", "text"])
                      ], 512 /* NEED_PATCH */))
                    : _createCommentVNode("v-if", true),
                  (_ctx.line1)
                    ? (_openBlock(), _createElementBlock("h4", {
                        key: 3,
                        class: _normalizeClass(_ctx.getClass('modal-title')),
                        style: _normalizeStyle({ ..._ctx.styleLine1 })
                      }, _toDisplayString(_ctx.line1.content), 7 /* TEXT, CLASS, STYLE */))
                    : _createCommentVNode("v-if", true),
                  (_ctx.line2)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 4,
                        class: _normalizeClass(_ctx.getClass('modal-description')),
                        style: _normalizeStyle({ ..._ctx.styleLine2 })
                      }, _toDisplayString(_ctx.line2.content), 7 /* TEXT, CLASS, STYLE */))
                    : _createCommentVNode("v-if", true),
                  (_ctx.html)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 5,
                        class: _normalizeClass(_ctx.getClass('modal-html-carousel')),
                        style: _normalizeStyle({ ..._ctx.styleHtml }),
                        innerHTML: _ctx.html && _ctx.html.content
                      }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_5))
                    : _createCommentVNode("v-if", true),
                  (_ctx.toggleTag.isBottomContentTag)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_ContainerTag, {
                          "tag-style": _ctx.styleTag,
                          text: _ctx.tagContent
                        }, null, 8 /* PROPS */, ["tag-style", "text"])
                      ], 512 /* NEED_PATCH */))
                    : _createCommentVNode("v-if", true),
                  (_ctx.showButton)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 7,
                        ref: "modalButtonWrapper",
                        class: _normalizeClass(_ctx.getClass('modal-button-wrapper'))
                      }, [
                        (_ctx.toggleTag.isTopButtonTag)
                          ? (_openBlock(), _createBlock(_component_ContainerTag, {
                              key: 0,
                              "tag-style": _ctx.styleTag,
                              text: _ctx.tagContent
                            }, null, 8 /* PROPS */, ["tag-style", "text"]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.button1 && _ctx.button1.label)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 1,
                              component: _ctx.button1Component,
                              messageContentsettings: _ctx.settings,
                              onClick: _ctx.onClickButton,
                              customStyle: _ctx.styleButton1
                            }, null, 8 /* PROPS */, ["component", "messageContentsettings", "onClick", "customStyle"]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.button2 && _ctx.button2.label)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 2,
                              component: _ctx.button2Component,
                              messageContentsettings: _ctx.settings,
                              onClick: _ctx.onClickButton,
                              customStyle: _ctx.styleButton2
                            }, null, 8 /* PROPS */, ["component", "messageContentsettings", "onClick", "customStyle"]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.button3 && _ctx.button3.label)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 3,
                              component: _ctx.button3Component,
                              messageContentsettings: _ctx.settings,
                              onClick: _ctx.onClickButton,
                              customStyle: _ctx.styleButton3
                            }, null, 8 /* PROPS */, ["component", "messageContentsettings", "onClick", "customStyle"]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.toggleTag.isBottomButtonTag)
                          ? (_openBlock(), _createBlock(_component_ContainerTag, {
                              key: 4,
                              "tag-style": _ctx.styleTag,
                              text: _ctx.tagContent
                            }, null, 8 /* PROPS */, ["tag-style", "text"]))
                          : _createCommentVNode("v-if", true)
                      ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */))
          ], 6 /* CLASS, STYLE */)
        ], 2 /* CLASS */))
  ]))
}